import {
  ASSESSMENT_URL,
  ASSESSMENT_POST_URL,
  ASSESSMENTID_GET_URL,
  RADHAS_ASSESSMENT_DIAGNOSE_URL,
  RADHAS_RESULTS_CONDITIONS_URL,
} from './constants';
import useAxios from '../hooks/useAxios';

/**
 * Hook for interacting with the Assessment API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useAssessmentApi = () => {
  const api = useAxios();

  /**
   * Posts an assessment to the server.
   *
   * @param {string} symptomDescription - Description of the symptoms.
   * @param {string} symptomStarted - Date when the symptoms started.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postAssessment = (symptomDescription, symptomStarted) => {
    if (symptomDescription === undefined && symptomStarted === undefined) {
      return api.post(ASSESSMENT_POST_URL, {});
    }
    return api.post(ASSESSMENT_POST_URL, {
      symptoms_description: symptomDescription,
      symptoms_started_at: symptomStarted,
    });
  };


  const patchAssessment = (assessmentId, symptomDescription, symptomStarted) => {
    console.log(assessmentId, symptomDescription, symptomStarted);
    
    // if (symptomDescription === undefined && symptomStarted === undefined) {
    //   return api.pacth(`${ASSESSMENTID_GET_URL}${assessmentId}` , {
    //     symptoms_description: ,
    //     symptoms_started_at: symptomStarted,
    //   });
    // }
    return api.patch(`${ASSESSMENTID_GET_URL}${assessmentId}`, {
      symptoms_description: symptomDescription,
      symptoms_started_at: symptomStarted,
    });
  };
  

  /**
   * Gets an assessment by user ID or the latest assessment if no user ID is provided.
   *
   * @param {string} userId - The ID of the user.
   * @returns {Promise} A Promise that resolves with the assessment data.
   */
  const getAssessment = userId => (userId ? api.get(`${ASSESSMENT_URL}/${userId}`) : api.get(ASSESSMENTID_GET_URL));

  /**
   * Gets the latest assessment.
   *
   * @returns {Promise} A Promise that resolves with the latest assessment data.
   */
  const getLatestAssessment = () => api.get(ASSESSMENTID_GET_URL);

  /**
   * Posts RADHAS assessment diagnosis for a specific assessment ID.
   *
   * @param {string} assessmentID - The ID of the assessment.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postRadhasAssessmentDiagnose = assessmentID =>
    api.post(`${ASSESSMENT_URL}/${assessmentID}/${RADHAS_ASSESSMENT_DIAGNOSE_URL}`, assessmentID);

  const postAnonAssessmentDiagnose = (assessment) =>
    api.post(`${ASSESSMENT_URL}/${RADHAS_ASSESSMENT_DIAGNOSE_URL}/anon`, assessment);

  /**
   * Gets results for a specific assessment ID.
   *
   * @param {string} assessmentID - The ID of the assessment.
   * @returns {Promise} A Promise that resolves with the assessment results.
   */
  const getResultsAssessment = assessmentID => api.get(`${RADHAS_RESULTS_CONDITIONS_URL}/${assessmentID}`);

  /**
   * Gets the next needed tool for a specific assessment ID.
   *
   * @param {string} assessmentID - The ID of the assessment.
   * @returns {Promise} A Promise that resolves with the next needed tool data.
   */
  const getNextNeededTool = assessmentID => api.get(`${ASSESSMENT_URL}/${assessmentID}/tool/next`);

  return {
    postAssessment,
    getAssessment,
    getLatestAssessment,
    postRadhasAssessmentDiagnose,
    postAnonAssessmentDiagnose,
    getResultsAssessment,
    getNextNeededTool,
    patchAssessment
  };
};
